import { render, staticRenderFns } from "./BlogsViewChart.vue?vue&type=template&id=fd2bfd34"
import script from "./BlogsViewChart.vue?vue&type=script&lang=js"
export * from "./BlogsViewChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports